import NP from 'number-precision'

export function format(value: number) {
  return NP.strip(Number(value) / 100)
}

export function checkPrice(value: string | number) {
  return /^\d+(\.\d{1,2})?$/.test(`${value}`)
}